import { render, staticRenderFns } from "./HrPolicy.vue?vue&type=template&id=03368880&scoped=true&"
import script from "./HrPolicy.vue?vue&type=script&lang=js&"
export * from "./HrPolicy.vue?vue&type=script&lang=js&"
import style0 from "./HrPolicy.vue?vue&type=style&index=0&id=03368880&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03368880",
  null
  
)

/* custom blocks */
import block0 from "./HrPolicy.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports